<sc-activity-list-item [activity]="activity" [showProjectName]="showProjectName" [condensed]="condensed" [hideUserName]="context == 'candidate'">
    <i scActivityIcon class="fa-sharp fa-solid fa-user-plus"></i>
    @if (context == 'candidate') { {{ texts.companyPoolOnboardingCandidateContext[language] }} } @else { {{ texts.companyPoolOnboarding[language] }} }
</sc-activity-list-item>
